import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router.js";
// import Amplify from "aws-amplify";
import store from "./store.js";
import axios from "axios";
import VueAxios from "vue-axios";
import VueTransmit from "vue-transmit";
import SequentialEntrance from "vue-sequential-entrance";
import "vue-sequential-entrance/vue-sequential-entrance.css";
import AOS from "aos";
import "aos/dist/aos.css";
Vue.use(SequentialEntrance);



// import * as VueGoogleMaps from 'vue2-google-maps'

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyA85fvcfqP49ZMJJq-djcxahugmRjNR8TI',
//     libraries: 'places', // This is required if you use the Autocomplete plugin
//   }
// }),

// setTimeout(() => {
//   console.log("coming here", store.getters.get_build_value);
//   var new_bild_value = store.getters.get_build_value;
//   if (new_bild_value == "dev") {
//     window.auth = {
//       userPoolId: "ap-southeast-1_Q8jiM3858",
//       region: "ap-southeast-1",
//       userPoolWebClientId: "4ra5v1ei35oq0ikkp4mqn3dd4s",
//     };
//   } else if (new_bild_value == "www") {
//     window.auth = {
//       userPoolId: "ap-southeast-1_m2C4gMJjW",
//       region: "ap-southeast-1",
//       userPoolWebClientId: "751ndlvkp100sav4hkn51pvb1o",
//     };
//   } else if (new_bild_value == "staging") {
//     window.auth = {
//       userPoolId: "ap-southeast-1_QbvJkE5DV",
//       region: "ap-southeast-1",
//       userPoolWebClientId: "4rgk9vmrifapa8l9hcccgpglob",
//     };
//   }

//   // console.log("new_bild_value", new_bild_value);
//   // console.log("auth", window.auth);
//   Amplify.configure({
//     Auth: window.auth,
//   });
//   // console.log("Amplify", Amplify);
// }, 1000);

Vue.use(VueTransmit);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

// Amplify.configure({
//   Auth: {
//     userPoolId: "ap-southeast-1_Q8jiM3858",
//     region: "ap-southeast-1",
//     userPoolWebClientId: "4ra5v1ei35oq0ikkp4mqn3dd4s",
//   },
//   // for UAT//
//   // Auth: {
//   //   userPoolId: "ap-southeast-1_m2C4gMJjW",
//   //   region: "ap-southeast-1",
//   //   userPoolWebClientId: "751ndlvkp100sav4hkn51pvb1o",
//   // },

//   // for dev
//   // Auth: {
//   //   userPoolId: "ap-southeast-1_Q8jiM3858",
//   //   region: "ap-southeast-1",
//   //   userPoolWebClientId: "4ra5v1ei35oq0ikkp4mqn3dd4s",
//   // },

//   // for staging
//   // Auth: {
//   //   userPoolId: "ap-southeast-1_u7QY8ssrS",
//   //   region: "ap-southeast-1",
//   //   userPoolWebClientId: "4a9qu1gqp91ibqti7kfgm97vah",
//   // },
//   API: {
//     endpoints: [
//       {
//         name: "getuserdetails",
//         endpoint: "https://liql60b1h9.execute-api.ap-south-1.amazonaws.com",
//       },
//     ],
//     aws_project_region: "ap-south-1",
//     aws_appsync_graphqlEndpoint:
//       "https://ebnkr5tnoneehjzyqevhigmr4e.appsync-api.ap-south-1.amazonaws.com/graphql",
//     aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
//   },
// });

new Vue({
  created(){
AOS.init()
  },
  router,
  store,
  vuetify,
  render: (h) => h(App),
  poll: true,
}).$mount("#app");
